<template>
  <div v-if="notifications.length > 0" class="dropdown_menu">
    <h3 class="ml_15 pb_15 pt_15" style=" border-bottom: 1px solid #ddd; margin-right: 15px;">Notifications</h3>
    <ul>
      <li class="d-block" :class="{background : !notification.read_at}" v-for="(notification, index) in notifications" :key="'request_'+index">
        <a role="button" @click="markAsRead(notification)">{{ notification.data.title }}</a>
        <p class="ml_15 mb_0">{{ notification.created_at }}</p>
      </li>
    </ul>
    <!--                      <router-link :to="{name: 'support-requests'}" class="btn btn_sm btn_black has_border_radius">View all</router-link>-->
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";

export default {
  name: 'HeaderNotificationsComponent',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      notifications: 'notification/notificationList',
    })
  },
  watch: {
    $route() {
      window.$(".dropdown_menu").removeClass('open')
    },
  },
  methods: {
    markAsRead(notification){
      this.axios.post(`/mark-as-read-notification/${notification.id}`)
          .then(() => {
            store.dispatch('notification/getNotifications')
            this.$router.push(notification.data.notify_url + '?ref=from_notification')
          })
    }
  },
}
</script>

<style scoped>
.dropdown_menu{
  min-width: 250px;
}
.background{
  background: #F6F6F6;
  margin-bottom: 5px;
  padding: 5px 0;
}
</style>